import clsx from 'clsx'
import React from 'react'

import { Checkbox } from '../Checkbox'
import { ROW_BG_CLASSES, ROW_BORDER_CLASSES, ROW_FOCUS_CLASSES } from './constants'
import { StickyCellBorder } from './StickyCellBorder'

interface TableSelectionCellProps extends Omit<React.TdHTMLAttributes<HTMLTableCellElement>, 'className' | 'onSelect'> {
  accessibleLabel?: string;
  defaultSelected?: boolean;
  disabled?: boolean;
  onSelect?: React.ChangeEventHandler<HTMLInputElement>
  selected?: boolean;
  sticky?: boolean;
}

export function TableSelectionCell ({
  accessibleLabel = 'Select row',
  defaultSelected,
  disabled,
  onSelect,
  selected,
  sticky,
  ...props
}: TableSelectionCellProps) {
  return (
    <td
      {...props}
      className={clsx(
        'body text-left font-normal text-gray-800 transition p-0 w-0 group/cell',
        ROW_FOCUS_CLASSES,
        ROW_BG_CLASSES,
        ROW_BORDER_CLASSES,
        {
          sticky,
          'z-10': sticky,
        }
      )}
      data-sticky={sticky}
    >
      <div className='flex items-center'>
        <label className='py-2 pr-3 group-last/cell:pr-[var(--cell-spacing)] group-first/cell:pl-[var(--cell-spacing)] flex items-center'>
          <Checkbox
            aria-label={accessibleLabel}
            checked={selected}
            defaultChecked={defaultSelected}
            disabled={disabled}
            onChange={onSelect}
          />
        </label>
      </div>
      <StickyCellBorder sticky={sticky} />
    </td>
  )
}

TableSelectionCell.displayName = 'Table.SelectionCell'
